function requireEnvValue(name: string, value: string | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed) {
    throw new Error(`${name} is not configured`);
  }

  return trimmed;
}

export function getSupabaseUrl(): string {
  return requireEnvValue("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL);
}

export function getSupabaseAnonKey(): string {
  return requireEnvValue("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY);
}
